<template>
  <v-content>
    <v-container>
      <list
        ref="list"
        :title="title"
        :headers="headers"
        :data="data"
        :response="response"
        :loading="loading"
        @edit="editFn"
        @delete="deleteFn"
        @details="previewFn"
        @new="newFn"
        @reload="loadModels()"
        @hook:mounted="handleMount('list')"
      >
        <template v-slot:select-headers>
          <filter-menu
            ref="filterMenu"
            :headers="headerOptions"
            :filters="filterOptions"
            :menu="filterMenu"
            :show-filter-options="true"
            location="models"
            @close="handleCloseFilterMenu"
            @update:headers="handleUpdateHeaders"
            @update:filters="handleUpdateFilters()"
            @hook:mounted="handleMount('filterMenu')"
          ></filter-menu>
        </template>
      </list>
      <delete-dialog
        :dialog="deleteDialog"
        :item="modelName"
        @agree="remove"
        v-show="false"
      />
    </v-container>
  </v-content>
</template>

<script>
import api from "@/utils/api.js";
import List from "@/components/lists/BuilderList.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import snackbar from "@/utils/snackbar.js";
import FilterMenu from "@/components/general/FilterMenu.vue";

export default {
  components: {
    List,
    DeleteDialog,
    FilterMenu,
  },
  data: () => ({
    mounted: {
      filterMenu: { mounted: false, refs: "filterMenu" },
      list: { mounted: false, refs: "list" },
      root: { mounted: false, refs: null },
    },
    filterMenu: false,
    filtersSelected: [],
    filterOptions: {
      title: "",
      items: [{ title: "", options: [{ text: "", value: "" }] }],
    },
    headerOptions: [],
    headers: [],
    data: [],
    sort: "name",
    title: "",
    deleteDialog: false,
    model: null,
    modelName: null,
    response: null,
    loading: true,
  }),
  created() {
    this.setInitalData();
  },

  mounted() {
    //NOTE: this is here to prevent multiple API calls to the same function. To gether all the parameters from the different components.
    this.handleMount("root");
  },
  methods: {
    handleMount(componentName) {
      if (!this.mounted.hasOwnProperty(componentName)) {
        console.error("MODELS:component name does not exists", componentName);
        return;
      }

      this.mounted[componentName] = {
        ...this.mounted[componentName],
        mounted: true,
      };

      if (Object.values(this.mounted).every((item) => item.mounted)) {
        this.loadModels();
      }
    },
    setInitalData() {
      this.filterOptions = {
        title: this.$t("builder.models.list.filterModelsBy"),
        items: [
          {
            title: this.$t("builder.models.list.source"),
            feature: "can_oem_manage_non_group_boats",
            options: [
              {
                text: this.$t("builder.models.list.all"),
                value: "source_all",
                active: true,
                default: true,
                server: { name: "is_external_brand", value: null },
              },

              {
                text: this.$t("builder.models.list.organizationBoats"),
                value: "source_organization_boats_only",
                active: false,
                default: false,
                server: { name: "is_external_brand", value: false },
              },
              {
                text: this.$t("builder.models.list.nonOrganizationBoats"),
                value: "source_non_organization_boats_only",
                active: false,
                default: false,
                server: { name: "is_external_brand", value: true },
              },
            ],
          },
          {
            title: this.$t("builder.models.list.productionState"),
            feature: null,
            options: [
              {
                text: this.$t("builder.models.list.all"),
                value: "production_state_all",
                active: true,
                default: true,
                server: { name: "is_in_production", value: null },
              },

              {
                text: this.$t("builder.models.list.inProduction"),
                value: "production_state_in_production",
                active: false,
                default: false,
                server: { name: "is_in_production", value: true },
              },
              {
                text: this.$t("builder.models.list.notInProduction"),
                value: "production_state_not_in_production",
                active: false,
                default: false,
                server: { name: "is_in_production", value: false },
              },
            ],
          },
        ],
      };
      this.headerOptions = [
        {
          text: this.$t("builder.models.list.brand"),
          align: "left",
          sortable: false,
          value: "brand_name",
          canHide: true,
        },
        {
          text: this.$t("builder.models.list.model"),
          align: "left",
          value: "model",
          sortable: false,
          canHide: true,

          //width: "400px"
        },
        {
          text: this.$t("builder.models.list.description"),
          align: "left",
          value: "comment",
          sortable: false,
          canHide: true,

          width: "500px",
        },
        {
          text: "",
          align: "right",
          value: "action",
          sortable: false,
          canHide: false,
        },
      ];
      this.title = this.$t("builder.models.list.models");
    },

    handleCloseFilterMenu(value) {
      this.filterMenu = value;
    },

    handleUpdateHeaders(headers, menu = true) {
      this.headers = this.headerOptions.filter((item) => {
        return headers.includes(item.value) || !item.canHide;
      });
      this.filterMenu = menu;
    },

    handleUpdateFilters() {
      if (this.$refs.list == null) return;
      this.$refs.list.setPage(1);
      this.loadModels();
    },

    loadModels() {
      let params = {};

      for (const key in this.mounted) {
        const refs = this.mounted[key].refs;
        if (refs == null) continue;
        params = {
          ...params,
          ...this.$refs[refs].query,
        };
      }

      this.$router.replace({
        name: this.$route.name,
        query: params,
      });

      api.getModelList(params).then((resp) => {
        this.response = resp.data;
        this.data = resp.data.results;
        this.loading = false;
      });
    },
    editFn(item) {
      this.$router.push({
        name: "modelsEdit",
        params: { id: item.uuid },
      });
    },

    deleteFn(item) {
      this.deleteDialog = true;
      this.model = item;
      this.modelName = item.brand_name + " " + item.model;
    },

    remove(agreed) {
      if (agreed) {
        api.deleteModel(this.model.uuid).then((resp) => {
          snackbar.success(
            this.$t("utils.snackbar.success.successfullyDeleted")
          );
          this.loadModels();
        });
      }
      this.deleteDialog = false;
    },
    previewFn(item) {
      this.$router.push({
        name: "modelsDetails",
        params: { id: item.uuid, action: "preview" },
      });
    },
    newFn(item) {
      this.$router.push({
        name: "modelsNew",
      });
    },
  },
};
</script>
